import React from 'react';
import MainLayout from '../layouts/MainLayout';
import CalendarView from '../components/Calendar/CalendarView';

const Calendar = () => {
  return (
    <MainLayout>
      <div className="p-2 sm:p-6">
        <CalendarView />
      </div>
    </MainLayout>
  );
};

export default Calendar;

